import { createReducer } from 'reduxsauce';
import { Types, DonatePageState, IPage } from './types';
import { INITIAL_STATE } from './initialState';

export const donatePageStart = state => ({
  ...state,
  isLoading: true,
  error: null,
});

export const donatePageSuccess = (state: DonatePageState, { data }: { data: IPage }) => ({
  ...state,
  data: {
    ...data,
    donation_amounts: data.donation_amounts?.map(amount => amount / 100) ?? [10, 25, 50, 100],
  },
  isLoading: false,
  hasResolved: true,
});

export const donatePageError = (state, { error }) => ({
  ...state,
  error,
  isLoading: false,
  hasResolved: true,
});

export const donatePageCleanUp = () => INITIAL_STATE;

export const HANDLERS = {
  [Types.DONATE_PAGE_START]: donatePageStart,
  [Types.DONATE_PAGE_SUCCESS]: donatePageSuccess,
  [Types.DONATE_PAGE_ERROR]: donatePageError,
  [Types.DONATE_PAGE_CLEAN_UP]: donatePageCleanUp,
};

export default createReducer(INITIAL_STATE, HANDLERS);
